/* Poster-first Shopify media. No player network/initialization until activation. */
if (!customElements.get('midi-deferred-media')) customElements.define('midi-deferred-media', class extends HTMLElement {
  connectedCallback() {
    this.listeners?.abort(); this.listeners = new AbortController();
    this.querySelector('[data-play]')?.addEventListener('click', () => this.activate(), {signal:this.listeners.signal});
  }
  async activate() {
    this.closest('product-gallery')?.pauseAll();
    const poster=this.querySelector('[data-play]');
    const error=this.querySelector('[data-media-error]');
    if(error)error.hidden=true;
    try {
      if(!this.player){
        const template=this.querySelector('[data-player-template]');
        const player=template?.content.firstElementChild?.cloneNode(true);
        if(!player)return;
        this.append(player);this.player=player;
        player.addEventListener('error',()=>this.fail(),{signal:this.listeners.signal});
        if(player.tagName==='MODEL-VIEWER')this.loadModel(player);
      }
      poster.hidden=true;
      this.player.focus();
      if(this.player.tagName==='VIDEO')await this.player.play();
    } catch (_) { this.fail(); }
  }
  fail(){const p=this.querySelector('[data-play]');if(p)p.hidden=false;const e=this.querySelector('[data-media-error]');if(e)e.hidden=false;}
  loadModel(player){
    if(!window.Shopify?.loadFeatures)return;
    if(!document.querySelector('link[data-midi-model-style]')){
      const link=document.createElement('link');link.rel='stylesheet';link.href='https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';link.dataset.midiModelStyle='';document.head.append(link);
    }
    window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:errors=>{if(!errors&&this.isConnected&&window.Shopify.ModelViewerUI&&!this.viewer)this.viewer=new window.Shopify.ModelViewerUI(player);}}]);
  }
  pause(){
    if(this.player?.tagName==='VIDEO')this.player.pause();
    if(this.player?.tagName==='IFRAME'){
      let origin;try{origin=new URL(this.player.src).origin;}catch(_){return;}
      if(origin==='https://www.youtube.com'||origin==='https://www.youtube-nocookie.com')this.player.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}),origin);
      if(origin==='https://player.vimeo.com')this.player.contentWindow?.postMessage(JSON.stringify({method:'pause'}),origin);
    }
    this.viewer?.pause();
  }
  disconnectedCallback(){this.pause();this.listeners?.abort();}
});
